import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./style.module.css";
import QuestionTitle from "../QuestionTitle";
import TestImageImg from "../../../../../assets/images/joftPooch/pictureTestImg.jpg";
import ImageTestElement from "./ImageTestElement";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";
import CustomHint from "../../../../../assets/containers/CustomHint";

export default function TestImageQuestion() {
  const dispatch = useDispatch();
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
  const [options, setOptions] = useState([]);
  const { currentQuestion, wrongAnswers, rightAnswer } = useSelector(
    ({ quiz }) => quiz
  );

  useEffect(() => {
    if (currentQuestion) {
      let receivedOptions = [
        {
          option: "الف",
          src: currentQuestion.optionA,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionA") : false,
        },
        {
          option: "ب",
          src: currentQuestion.optionB,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionB") : false,
        },
        {
          option: "ج",
          src: currentQuestion.optionC,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionC") : false,
        },
        {
          option: "د",
          src: currentQuestion.optionD,
          selected: false,
          wrong: wrongAnswers ? wrongAnswers.includes("optionD") : false,
        },
      ];
      setOptions(receivedOptions);
    }
    return () => {
      setOptions([]);
    };
  }, [currentQuestion, wrongAnswers]);

  useEffect(() => {
    if (currentQuestion) {
      const allOpts = ["optionA", "optionB", "optionC", "optionD"];
      let selected = options.indexOf(
        options.find((option) => option.selected === true)
      );
      if (selected !== -1) {
        dispatch(
          setQuestionAnswer({
            questionId: currentQuestion._id,
            userOptionAnswer: allOpts[selected],
          })
        );
      } else {
        dispatch(setQuestionAnswer(null));
      }
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [options, currentQuestion]);

  const selectOption = (selected, index) => {
    if (soudMuted) {
      TickAudio.play();
    }
    const updatedUptions = [...options];
    const selectedBefore = updatedUptions.indexOf(
      options.find((option) => option.selected === true)
    );
    if (selectedBefore !== -1 && selectedBefore !== index) {
      updatedUptions[selectedBefore].selected = false;
    }

    updatedUptions[index].selected = selected;
    setOptions(updatedUptions);
  };

  useEffect(() => {
    if (wrongAnswers && options.length > 0) {
      const updatedOptions = options.map((option, index) => {
        const isWrong = wrongAnswers.includes(
          `option${String.fromCharCode(65 + index)}`
        );
        return {
          ...option,
          wrong: isWrong,
          selected: isWrong ? false : option.selected,
        };
      });
      const hasChanged = !updatedOptions.every(
        (option, index) =>
          option.wrong === options[index].wrong &&
          option.selected === options[index].selected
      );

      if (hasChanged) {
        setOptions(updatedOptions);
      }
    }
  }, [wrongAnswers]);

  function getRightAnswer(rightAnswer) {
    switch (rightAnswer) {
      case "optionA":
        return "الف";
      case "optionB":
        return "ب";
      case "optionC":
        return "ج";
      case "optionD":
        return "د";
      default:
        break;
    }
  }

  return (
    <div className="w-100">
      {rightAnswer && (
        <div className="my-5">
          <CustomHint hint={`پاسخ صحیح: ${getRightAnswer(rightAnswer)}`} />
        </div>
      )}
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? `${baseURL}file/get/${currentQuestion.cover}`
                : TestImageImg
              : TestImageImg
            : TestImageImg
        }
      />
      <div className={classes.testImageOptions}>
        {options.map((option, index) => {
          return (
            <ImageTestElement
              text={option.option}
              selected={option.selected}
              wrong={option.wrong}
              src={option.src}
              handleSelect={(selected) => selectOption(selected, index)}
              key={index}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
}
